import type { JSX } from 'react'

import { useUnit } from 'effector-react'
import * as era from '~/core/era'
import { ui } from '~/core/skin'
import { model as showsRootEntity } from '~/entities/shows/root'
import { ModuleAppTitle } from '~/features/appearance'
import { STATIC_IDENTIFIERS } from '~/shared/appearance'
import { Skeleton } from '~/shared/ui/components/Skeleton'
import { $detailsTitle } from '~/shared/ui/translations/general-translations'
import { ModuleBannerCarousel } from '~/widgets/Banners/ModuleBannerCarousel'
import * as showsModel from './model'
import * as showsSkeletonModel from './skeleton'

export function Title(): JSX.Element {
  return (
    <ModuleAppTitle identifier={STATIC_IDENTIFIERS.SHOW} fallbackKey='series' />
  )
}

const skin = era.skin('routes/shows/root')

ShowsPage.displayName = 'ShowsPage'
export function ShowsPage(): JSX.Element {
  const [
    isContentLoading,
    carousels,
    isBannersLoading,
    bannerCarouselShown,
    detailsTitle,
    isEmptyPage,
  ] = useUnit([
    showsSkeletonModel.$contentLoading,
    showsModel.$bannerCarousels,
    showsRootEntity.getBannersFx.pending,
    showsModel.$bannerShowsCarouselShown,
    $detailsTitle,
    showsModel.$isShowsEmptyPage,
  ])

  // the empty state centres itself with `flexGrow`, which needs a flex parent
  return (
    <ui.SkinContext value={skin}>
      <ui.PageWrapper className={isEmptyPage ? 'flex-column' : ''}>
        <Skeleton pageType='main' isLoading={isContentLoading}>
          {bannerCarouselShown && (
            <ModuleBannerCarousel
              carousels={carousels}
              isLoading={isBannersLoading}
              dataTestId='show-banners'
              detailsCategoryName='TV Shows'
              detailsTitle={detailsTitle}
            />
          )}
          <ui.RenderSkin name='featured' />
          <ui.RenderSkin name='bundlesShows' />
          <ui.RenderSkin name='categories' />
          <ui.RenderSkin name='infiniteCategory' />
          <ui.RenderSkin name='showsEmptyPage' />
        </Skeleton>
      </ui.PageWrapper>
    </ui.SkinContext>
  )
}
